import React, { useState, useRef, useEffect } from "react";
import { Button, Popover, TextField } from "@mui/material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import PopOver from "../PopOver";

import HGraph from "components/Custom/HGraph";
import { FORMATS, GRAPH_TYPES } from "common/config";
import { COLORS } from "common/colors";
import { REPORTS_APIs } from "apihandlers/reports";
import { LABELS } from "common/lables";
import SkeletonBox from "components/Custom/SkeletonBox";

import "./styles.css";
import Btn from "components/Custom/Btn";

const positiveGraph = require("assets/images/positiveGraph.png");
const negativeGraph = require("assets/images/negativeGraph.png");
const totalGraph = require("assets/images/total-graph.png");

const CustomerView = () => {
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(false);
  const [chartData, setChartData] = useState(null);
  const [filteredChartData, setFilteredChartData] = useState<any>(null);
  const [chartFilter, setChartFilter] = useState<any>("Zone");
  const [anchorEl, setAnchorEl] = useState();
  const [popstatus, setPopstatus] = useState(false);
  const [stateCharts, setStateCharts] = useState(null);
  const [zoneCharts, setZoneCharts] = useState(null);
  const [rsmCharts, setRsmCharts] = useState(null);
  const [asmCharts, setAsmCharts] = useState(null);
  //filters
  const [zoneFilter, setZoneFilter] = useState([]);

  const [zonedata, setZoneData] = useState([]);
  const [stateFilter, setStateFilter] = useState([]);
  const [districtFilter, setDistrictFilter] = useState([]);

  const stateChart = [
    {
      name: "States",
      data: stateCharts,
    },
  ];

  const zoneChart = [
    {
      name: "Country Zones",
      colorByPoint: true,
      data: zoneCharts,
    },
  ];

  const rsmChart = [
    {
      name: "RSM",
      colorByPoint: true,
      data: rsmCharts,
    },
  ];

  const asmChart = [
    {
      name: "ASM",
      colorBypoint: true,
      data: asmCharts,
    },
  ];
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handlePopStatus = (event) => {
    setAnchorEl(event.currentTarget);
    setPopstatus(true);
  };

  const handlePopoverClose = () => {
    setPopstatus(false);
    setAnchorEl(null);
  };

  useEffect(() => {
    if (loading) {
      getChart();
    }
  }, [loading]);

  // useEffect(() => {
  //   setTimeout(() => {
  //
  //   }, 8000);
  // }, []);

  const getChart = async () => {
    try {
      const args = {};
      const res = await REPORTS_APIs.getCustomerColumnChartData(args);
      const response: any = res.response;
      const { status } = res;
      setChartData(response);

      let zonesList = response.zoneChartData.category.map((item) => {
        return {
          id: item,
          label: item,
        };
      });

      setZoneData([
        {
          id: "All",
          label: "All",
        },
        ...zonesList,
      ]);

      let statesList = response.stateChartData.category.map((item) => {
        return {
          id: item,
          label: item,
        };
      });
      setStateFilter([
        {
          id: "All",
          label: "All",
          checked: true,
        },
        ...statesList,
      ]);

      let districtsList = response.districtChartData.category.map((item) => {
        return {
          id: item,
          label: item,
        };
      });
      setDistrictFilter([
        {
          id: "All",
          label: "All",
          checked: true,
        },
        ...districtsList,
      ]);
      setLoading(false);
    } catch (err) {
      console.log("error", err);
    }
  };
  // console.log("state", zoneFilter);

  const args = {};
  REPORTS_APIs.getCustomerPieChartData(args).then((res: any) => {
    const response: any = res.response;
    const { status } = res;
    let stateList = response.statechartData[0].data;
    setStateCharts(stateList);

    let zoneList = response.countrychartData[0].data;
    setZoneCharts(zoneList);

    let rsmList = response.rsmchartData[0].data;
    setRsmCharts(rsmList);

    let asmList = response.asmchartData[0].data;
    setAsmCharts(asmList);
  });

  const chartType = [
    "Zone",
    "State",
    "District",
    "Customer Category",
    "Business Category",
    "Sales Category",
  ];
  let categories = [];
  let series = [];
  const data = filteredChartData ? filteredChartData : chartData;
  console.log("dataChart", filteredChartData, data);
  if (data) {
    if (chartFilter === "Zone") {
      const zChartData = filteredChartData
        ? filteredChartData
        : chartData.zoneChartData;
      console.log("zChartData", zChartData);
      series = zChartData.data.map((item) => {
        return {
          name: item.name,
          data: item.data,
        };
      });
      // console.log("zoneSeries", series);
      categories = zChartData.category;
      // console.log("chartdatanew", zChartData);
    } else if (chartFilter === "State") {
      let state = chartData.stateChartData.data;
      series = state.map((item) => {
        return {
          name: item.name,
          data: item.data,
        };
      });
      categories = chartData.stateChartData.category;
    } else if (chartFilter === "District") {
      let state = chartData.districtChartData.data;
      series = state.map((item) => {
        return {
          name: item.name,
          data: item.data,
        };
      });
      categories = chartData.districtChartData.category;
    } else if (chartFilter === "Customer Category") {
      let state = chartData.customerTypeChartData.data;
      series = state.map((item) => {
        return {
          name: item.name,
          data: item.data,
        };
      });
      categories = chartData.customerTypeChartData.category;
    } else if (chartFilter === "Business Category") {
      let state = chartData.businessTypeChartData.data;
      series = state.map((item) => {
        return {
          name: item.name,
          data: item.data,
        };
      });
      categories = chartData.businessTypeChartData.category;
    } else if (chartFilter === "Sales Category") {
      let state = chartData.salesTypeChartData.data;
      series = state.map((item) => {
        return {
          name: item.name,
          data: item.data,
        };
      });
      categories = chartData.salesTypeChartData.category;
    }
  }
  // console.log("zonedata:", chartFilter, categories, series);

  const onFilter = (item) => {
    if (item === "Zone") {
      setRefresh(true);
      setChartFilter("Zone");
    } else if (item === "State") {
      setRefresh(true);
      setChartFilter("State");
    } else if (item === "District") {
      setRefresh(true);
      setChartFilter("District");
    } else if (item === "Customer Category") {
      setRefresh(true);
      setChartFilter("Customer Category");
    } else if (item === "Business Category") {
      setRefresh(true);
      setChartFilter("Business Category");
    } else if (item === "Sales Category") {
      setRefresh(true);
      setChartFilter("Sales Category");
    }
  };

  const onSelectZone = (tmpList) => {
    console.log("tmpList", tmpList);
    let zoneChartData = chartData.zoneChartData;
    let zoneIndxList = [];
    let categories = zoneChartData.category;
    console.log("categories", categories);

    for (let i = 0; i < tmpList.length; i++) {
      // its in categories
      if (categories.indexOf(tmpList[i]) > -1) {
        zoneIndxList.push(categories.indexOf(tmpList[i]));
      }
      console.log(tmpList[i], "=>", categories.indexOf(tmpList[i]));
    }
    console.log("zoneIndxList", zoneIndxList);
    console.log("zoneChartData.data", zoneChartData.data);

    zoneChartData.data = zoneChartData.data.map((i) => {
      // console.log("i", i.data);
      i.data = i.data.filter((d, w) => {
        return zoneIndxList.indexOf(w) > -1;
      });
      return i;
    });

    categories = categories.map((z) => {
      console.log("ategories", z);

      // z = z.filter((d, i) => {
      //   console.log("filtered:i", i);
      // });

      // z.category = z.category.filter((d, i) => {
      //   return zoneIndxList.indexOf(i) > -1;
      // });
      return z;
    });

    console.log("zoneChartData.data1", zoneChartData.data);
    console.log("categories", categories);

    setFilteredChartData(zoneChartData);

    // console.log("zdata", zoneChartData.data, zoneIndxList);
    // zoneChartData.data = zoneChartData.data.map((z) => {
    //   z.data = z.data.filter((d, i) => {
    //     return zoneIndxList.indexOf(i) > -1;
    //   });
    //   console.log("z", z);
    //   return z;
    // });
    // zoneChartData.category = zoneChartData.category.filter((z, i) => {
    //   return zoneIndxList.indexOf(i) > -1;
    // });
    // // categories = categories.map((z) => {
    // //   z = z.filter((d, i) => {
    // //     return zoneIndxList.indexOf(i) > -1;
    // //   });
    // //   return z;
    // // });
    // console.log(
    //   "onSelectZone: ",
    //   tmpList,
    //   zoneChartData.category,
    //   zoneChartData.data
    //   // zoneIndxList,
    // );
    // // setChartData(tmpList);
    setChartData(zoneChartData);
    // setFilteredChartData(zoneChartData.data);
  };

  const onReset = () => {
    setChartFilter("Zone");
  };

  const ColumnChart = {
    chart: {
      type: "column",

      marginTop: 50,
      borderRadius: 20,
    },
    title: {
      text: "",
      align: "left",
    },
    xAxis: {
      categories: categories,
      crosshair: true,
      accessibility: {
        description: "",
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: "Sales",
      },
    },
    credits: false,
    tooltip: {
      valueSuffix: "",
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
        dataLabels: {
          borderWidth: 0,
        },
      },
    },
    colors: ["#FF4F00", "#CE2029", "#01b8aa", "#03C03C", "#6082B6", "#f48522"],
    series: series,
  };
  console.log(" chartData.zoneChartData", chartData);
  return loading ? (
    <>
      <div className="graphContainer">
        <div style={{ width: "100%", display: "flex" }}>
          <SkeletonBox
            height={30}
            width={"20%"}
            style={{
              position: "relative",
              left: "2rem",
              width: "7%",
            }}
          />
          <div
            style={{
              display: "flex",
              gap: "2rem",
              placeContent: "flex-end",
              marginRight: "49px",
              width: "90%",
            }}
          >
            <SkeletonBox height={30} width={"7%"} />
            <SkeletonBox height={30} width={"7%"} />
          </div>
        </div>
        <div
          className="graphDashboard"
          style={{ width: "98%", left: "1.4rem" }}
        >
          <SkeletonBox
            height={400}
            width={"100%"}
            style={{ borderRadius: "1rem" }}
          />
        </div>
      </div>
      <div className="salesContainer" style={{ width: "100%", left: "1rem" }}>
        <SkeletonBox
          height={800}
          width={"98%"}
          style={{ borderRadius: "1rem", left: "1rem", marginRight: "10rem" }}
        />
      </div>
      <div className="graphContainer" style={{ width: "100%", left: "0.4rem" }}>
        <div className="graphWrapper">
          <div className="graphDashboard">
            <SkeletonBox
              height={500}
              width={"100%"}
              style={{ borderRadius: "1rem", marginTop: "2rem" }}
            />
          </div>
          <div className="graphDashboard">
            <SkeletonBox
              height={500}
              width={"100%"}
              style={{ borderRadius: "1rem", marginTop: "2rem" }}
            />
          </div>
        </div>
        <div className="graphWrapper">
          <div className="graphDashboard">
            <SkeletonBox
              height={500}
              width={"100%"}
              style={{
                borderRadius: "1rem",
                marginTop: "1rem",
                marginBottom: "4rem",
              }}
            />
          </div>
          <div className="graphDashboard">
            <SkeletonBox
              height={500}
              width={"100%"}
              style={{
                borderRadius: "1rem",
                marginTop: "1rem",
                marginBottom: "4rem",
              }}
            />
          </div>
        </div>
      </div>
    </>
  ) : (
    <>
      <div className="graphContainer">
        {/* <PopOver
            data={stateFilter}
            name={LABELS.STATE}
            // onChange={(filterData) => {
            //   setStateFilter(filterData);
            //   commonFunction(zoneFilter, filterData, districtFilter);
            // }}
          />

          <PopOver
            data={districtFilter}
            name={LABELS.DISTRICT}
            // onChange={(filterData) => {
            //   setDistrictFilter(filterData);
            //   commonFunction(zoneFilter, stateFilter, filterData);
            // }}
          /> */}
        <div style={{ width: "100%", display: "flex" }}>
          <div style={{ position: "relative", left: "2rem", width: "50%" }}>
            <PopOver
              data={zonedata}
              name={LABELS.ZONE}
              onChange={(filterData) => {
                setZoneFilter(filterData);
                onSelectZone(filterData);
              }}
            />
          </div>
          <div
            style={{
              display: "flex",
              gap: "1rem",
              placeContent: "flex-end",
              marginRight: "49px",
              width: "50%",
            }}
          >
            <Btn
              variant="contained"
              endIcon={<FilterAltIcon />}
              onClick={handlePopStatus}
              text={chartFilter}
            />
            <Popover
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={handlePopoverClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
            >
              <div>
                {chartType.map((item) => {
                  return (
                    <Box
                      sx={{
                        width: "95%",
                        maxWidth: 360,
                        bgcolor: "background.paper",
                      }}
                    >
                      <List>
                        <ListItem disablePadding>
                          <ListItemButton
                            onClick={() => {
                              onFilter(item);
                              handlePopoverClose();
                            }}
                          >
                            <ListItemText primary={item} />
                          </ListItemButton>
                        </ListItem>
                      </List>
                    </Box>
                  );
                })}
              </div>
            </Popover>
            <Btn
              onClick={onReset}
              text={LABELS.RESET}
              bgColor={COLORS.RELOAD_EXPORT}
              color={COLORS.RELOAD_EXPORT_TEXT}
            />
          </div>
        </div>
        <div
          className="graphDashboard"
          style={{ width: "98%", left: "1.4rem" }}
        >
          {chartData || loading ? (
            <HGraph
              width={"100%"}
              height={"100%"}
              type={GRAPH_TYPES.COLUMN}
              float={"right"}
              title={"Column Graph"}
              exportTitle={"Column Graph Record"}
              xAxisTitle=""
              yAxisTitle="Leads"
              graphData={ColumnChart}
            />
          ) : (
            <SkeletonBox width={"100%"} height={100} />
          )}
        </div>
      </div>
      <div className="salesContainer">
        <div className="salesDashboardWrapper">
          <div className="salesDashboard">
            <div style={{ width: "70%" }}>
              <h4 style={{ margin: "30px 30px", color: "darkslategrey" }}>
                Jul 2022
              </h4>
              <h2 style={{ margin: "0px 30px" }}>
                <span>Rs 50,560.00 </span>{" "}
                <span
                  style={{
                    color: COLORS.GREEN,
                    paddingLeft: "2px",
                    fontSize: "1rem",
                  }}
                >
                  +2.5%
                </span>
              </h2>
              <h4 style={{ margin: "10px 30px" }}>
                <span style={{ color: "grey" }}>Vs last year: </span>
                <span>
                  <b>Rs 47,322.22</b>
                </span>
              </h4>
            </div>
            <div
              style={{
                width: "30%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={positiveGraph}
                width={"100%"}
                height={"50%"}
                style={{ position: "relative", right: "20px", top: "15px" }}
              />
            </div>
          </div>
          <div className="salesDashboard">
            <div style={{ width: "70%" }}>
              <h4 style={{ margin: "30px 30px", color: "darkslategrey" }}>
                Aug 2022
              </h4>
              <h2 style={{ margin: "0px 30px" }}>
                <span>Rs 40,560.00 </span>{" "}
                <span
                  style={{
                    color: COLORS.GREEN,
                    paddingLeft: "2px",
                    fontSize: "1rem",
                  }}
                >
                  +3.5%
                </span>
              </h2>
              <h4 style={{ margin: "10px 30px" }}>
                <span style={{ color: "grey" }}>Vs last year: </span>
                <span>
                  <b>Rs 37,322.22</b>
                </span>
              </h4>
            </div>
            <div
              style={{
                width: "30%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={positiveGraph}
                width={"100%"}
                height={"50%"}
                style={{ position: "relative", right: "20px", top: "15px" }}
              />
            </div>
          </div>
          <div className="salesDashboard">
            <div style={{ width: "70%" }}>
              <h4 style={{ margin: "30px 30px", color: "darkslategrey" }}>
                Sep 2022
              </h4>
              <h2 style={{ margin: "0px 30px" }}>
                <span>Rs 40,560.00 </span>{" "}
                <span
                  style={{
                    color: COLORS.RED,
                    paddingLeft: "2px",
                    fontSize: "1rem",
                  }}
                >
                  -3.5%
                </span>
              </h2>
              <h4 style={{ margin: "10px 30px" }}>
                <span style={{ color: "grey" }}>Vs last year: </span>
                <span>
                  <b>Rs 41,322.22</b>
                </span>
              </h4>
            </div>
            <div
              style={{
                width: "30%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={negativeGraph}
                width={"100%"}
                height={"50%"}
                style={{ position: "relative", right: "20px", top: "15px" }}
              />
            </div>
          </div>
          <div className="salesDashboard">
            <div style={{ width: "70%" }}>
              <h4 style={{ margin: "30px 30px", color: "darkslategrey" }}>
                Oct 2022
              </h4>
              <h2 style={{ margin: "0px 30px" }}>
                <span>Rs 47,560.00 </span>{" "}
                <span
                  style={{
                    color: COLORS.GREEN,
                    paddingLeft: "2px",
                    fontSize: "1rem",
                  }}
                >
                  +4.5%
                </span>
              </h2>
              <h4 style={{ margin: "10px 30px" }}>
                <span style={{ color: "grey" }}>Vs last year: </span>
                <span>
                  <b>Rs 41,322.22</b>
                </span>
              </h4>
            </div>
            <div
              style={{
                width: "30%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={positiveGraph}
                width={"100%"}
                height={"50%"}
                style={{ position: "relative", right: "20px", top: "15px" }}
              />
            </div>
          </div>
        </div>
        <div className="salesDashboardWrapper">
          <div className="salesDashboard">
            <div style={{ width: "70%" }}>
              <h4 style={{ margin: "30px 30px", color: "darkslategrey" }}>
                Nov 2022
              </h4>
              <h2 style={{ margin: "0px 30px" }}>
                <span>Rs 50,560.00 </span>{" "}
                <span
                  style={{
                    color: COLORS.RED,
                    paddingLeft: "2px",
                    fontSize: "1rem",
                  }}
                >
                  -2.5%
                </span>
              </h2>
              <h4 style={{ margin: "10px 30px" }}>
                <span style={{ color: "grey" }}>Vs last year: </span>
                <span>
                  <b>Rs 47,322.22</b>
                </span>
              </h4>
            </div>
            <div
              style={{
                width: "30%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={negativeGraph}
                width={"100%"}
                height={"50%"}
                style={{ position: "relative", right: "20px", top: "15px" }}
              />
            </div>
          </div>
          <div className="salesDashboard">
            <div style={{ width: "70%" }}>
              <h4 style={{ margin: "30px 30px", color: "darkslategrey" }}>
                Dec 2022
              </h4>
              <h2 style={{ margin: "0px 30px" }}>
                <span>Rs 40,560.00 </span>{" "}
                <span
                  style={{
                    color: COLORS.RED,
                    paddingLeft: "2px",
                    fontSize: "1rem",
                  }}
                >
                  -3.5%
                </span>
              </h2>
              <h4 style={{ margin: "10px 30px" }}>
                <span style={{ color: "grey" }}>Vs last year: </span>
                <span>
                  <b>Rs 37,322.22</b>
                </span>
              </h4>
            </div>
            <div
              style={{
                width: "30%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={negativeGraph}
                width={"100%"}
                height={"50%"}
                style={{ position: "relative", right: "20px", top: "15px" }}
              />
            </div>
          </div>
          <div className="salesDashboard">
            <div style={{ width: "70%" }}>
              <h4 style={{ margin: "30px 30px", color: "darkslategrey" }}>
                Jan 2023
              </h4>
              <h2 style={{ margin: "0px 30px" }}>
                <span>Rs 40,560.00 </span>{" "}
                <span
                  style={{
                    color: COLORS.GREEN,
                    paddingLeft: "2px",
                    fontSize: "1rem",
                  }}
                >
                  +3.5%
                </span>
              </h2>
              <h4 style={{ margin: "10px 30px" }}>
                <span style={{ color: "grey" }}>Vs last year: </span>
                <span>
                  <b>Rs 41,322.22</b>
                </span>
              </h4>
            </div>
            <div
              style={{
                width: "30%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={positiveGraph}
                width={"100%"}
                height={"50%"}
                style={{ position: "relative", right: "20px", top: "15px" }}
              />
            </div>
          </div>
          <div className="salesDashboard">
            <div style={{ width: "70%" }}>
              <h4 style={{ margin: "30px 30px", color: "darkslategrey" }}>
                Feb 2023
              </h4>
              <h2 style={{ margin: "0px 30px" }}>
                <span>Rs 47,560.00 </span>{" "}
                <span
                  style={{
                    color: COLORS.GREEN,
                    paddingLeft: "2px",
                    fontSize: "1rem",
                  }}
                >
                  +4.5%
                </span>
              </h2>
              <h4 style={{ margin: "10px 30px" }}>
                <span style={{ color: "grey" }}>Vs last year: </span>
                <span>
                  <b>Rs 41,322.22</b>
                </span>
              </h4>
            </div>
            <div
              style={{
                width: "30%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={positiveGraph}
                width={"100%"}
                height={"50%"}
                style={{ position: "relative", right: "20px", top: "15px" }}
              />
            </div>
          </div>
        </div>
        <div className="salesDashboardWrapper">
          <div className="salesDashboard">
            <div style={{ width: "70%" }}>
              <h4 style={{ margin: "30px 30px", color: "darkslategrey" }}>
                Mar 2023
              </h4>
              <h2 style={{ margin: "0px 30px" }}>
                <span>Rs 50,560.00 </span>{" "}
                <span
                  style={{
                    color: COLORS.GREEN,
                    paddingLeft: "2px",
                    fontSize: "1rem",
                  }}
                >
                  +2.5%
                </span>
              </h2>
              <h4 style={{ margin: "10px 30px" }}>
                <span style={{ color: "grey" }}>Vs last year: </span>
                <span>
                  <b>Rs 47,322.22</b>
                </span>
              </h4>
            </div>
            <div
              style={{
                width: "30%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={positiveGraph}
                width={"100%"}
                height={"50%"}
                style={{ position: "relative", right: "20px", top: "15px" }}
              />
            </div>
          </div>
          <div className="salesDashboard">
            <div style={{ width: "70%" }}>
              <h4 style={{ margin: "30px 30px", color: "darkslategrey" }}>
                Apr 2023
              </h4>
              <h2 style={{ margin: "0px 30px" }}>
                <span>Rs 40,560.00 </span>{" "}
                <span
                  style={{
                    color: COLORS.GREEN,
                    paddingLeft: "2px",
                    fontSize: "1rem",
                  }}
                >
                  +3.5%
                </span>
              </h2>
              <h4 style={{ margin: "10px 30px" }}>
                <span style={{ color: "grey" }}>Vs last year: </span>
                <span>
                  <b>Rs 37,322.22</b>
                </span>
              </h4>
            </div>
            <div
              style={{
                width: "30%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={positiveGraph}
                width={"100%"}
                height={"50%"}
                style={{ position: "relative", right: "20px", top: "15px" }}
              />
            </div>
          </div>
          <div className="salesDashboard">
            <div style={{ width: "70%" }}>
              <h4 style={{ margin: "30px 30px", color: "darkslategrey" }}>
                May 2023
              </h4>
              <h2 style={{ margin: "0px 30px" }}>
                <span>Rs 40,560.00 </span>{" "}
                <span
                  style={{
                    color: COLORS.RED,
                    paddingLeft: "2px",
                    fontSize: "1rem",
                  }}
                >
                  -3.5%
                </span>
              </h2>
              <h4 style={{ margin: "10px 30px" }}>
                <span style={{ color: "grey" }}>Vs last year: </span>
                <span>
                  <b>Rs 41,322.22</b>
                </span>
              </h4>
            </div>
            <div
              style={{
                width: "30%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={negativeGraph}
                width={"100%"}
                height={"50%"}
                style={{ position: "relative", right: "20px", top: "15px" }}
              />
            </div>
          </div>
          <div className="salesDashboard">
            <div style={{ width: "70%" }}>
              <h4 style={{ margin: "30px 30px", color: "darkslategrey" }}>
                Jun 2023
              </h4>
              <h2 style={{ margin: "0px 30px" }}>
                <span>Rs 47,560.00 </span>{" "}
                <span
                  style={{
                    color: COLORS.GREEN,
                    paddingLeft: "2px",
                    fontSize: "1rem",
                  }}
                >
                  +4.5%
                </span>
              </h2>
              <h4 style={{ margin: "10px 30px" }}>
                <span style={{ color: "grey" }}>Vs last year: </span>
                <span>
                  <b>Rs 41,322.22</b>
                </span>
              </h4>
            </div>
            <div
              style={{
                width: "30%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={positiveGraph}
                width={"100%"}
                height={"50%"}
                style={{ position: "relative", right: "20px", top: "15px" }}
              />
            </div>
          </div>
        </div>
        <div className="salesDashboardWrapper">
          <div className="salesDashboard">
            <div style={{ width: "70%" }}>
              <h4 style={{ margin: "30px 30px", color: "darkslategrey" }}>
                Total
              </h4>
              <h2 style={{ margin: "0px 30px" }}>
                <span>Rs 47,560.00 </span>{" "}
                <span
                  style={{
                    color: COLORS.GREEN,
                    paddingLeft: "2px",
                    fontSize: "1rem",
                  }}
                >
                  +4.5%
                </span>
              </h2>
              <h4 style={{ margin: "10px 30px" }}>
                <span style={{ color: "grey" }}>Vs last year: </span>
                <span>
                  <b>Rs 41,322.22</b>
                </span>
              </h4>
            </div>
            <div
              style={{
                width: "30%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={totalGraph}
                width={"100%"}
                height={"50%"}
                style={{ position: "relative", right: "20px", top: "15px" }}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="graphContainer" style={{ paddingTop: "12px" }}>
        <div className="graphWrapper">
          <div className="graphDashboard">
            <HGraph
              title={"States"}
              type={GRAPH_TYPES.PIE}
              series={stateChart}
              exportTitle={"Chart"}
              width={"100%"}
              height={"60%"}
            />
          </div>
          <div className="graphDashboard">
            <HGraph
              title={"Country Zones"}
              type={GRAPH_TYPES.PIE}
              series={zoneChart}
              exportTitle={"Chart"}
              width={"100%"}
              height={"60%"}
            />
          </div>
        </div>
        <div className="graphWrapper " style={{ marginBottom: "4rem" }}>
          <div className="graphDashboard">
            <HGraph
              title={"RSM"}
              type={GRAPH_TYPES.PIE}
              series={rsmChart}
              exportTitle={"Chart"}
              width={"100%"}
              height={"60%"}
            />
          </div>
          <div className="graphDashboard">
            <HGraph
              title={"ASM"}
              type={GRAPH_TYPES.PIE}
              series={asmChart}
              exportTitle={"Chart"}
              width={"100%"}
              height={"60%"}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomerView;
